import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { apiFetch } from '../api';
import { Btn, Spinner } from '../components';
import { AuthShell, AuthStatus, NewPasswordFields } from '../components/AuthForm';
import { passwordValidationError } from '../utils/passwordPolicy';

export default function ResetPassword({ token, onReturn }) {
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    const meta = document.createElement('meta'); meta.name = 'referrer'; meta.content = 'no-referrer';
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);
  const submit = async (event) => {
    event.preventDefault();
    if (saving) return;
    const invalid = passwordValidationError(password);
    if (invalid) return setError(invalid);
    if (password !== confirmation) return setError('As senhas não coincidem.');
    setSaving(true); setError('');
    try {
      const result = await apiFetch('/auth/reset-password', { method: 'POST', body: JSON.stringify({ token, nova_senha: password }) });
      setMessage(result.mensagem); setPassword(''); setConfirmation('');
    } catch (err) { setError(err.message); }
    finally { setSaving(false); }
  };
  return <AuthShell title={message ? 'Senha redefinida' : 'Defina uma nova senha'} description={message ? 'Suas sessões anteriores foram encerradas. Entre novamente para continuar.' : 'Use pelo menos 8 caracteres.'}>
    {message ? <AuthStatus message={message} /> : <form onSubmit={submit} style={{ display: 'grid', gap: 16 }}>
      <NewPasswordFields password={password} confirmation={confirmation} onPassword={setPassword} onConfirmation={setConfirmation} disabled={saving} />
      <AuthStatus error={error} />
      <Btn type="submit" disabled={saving} style={{ justifyContent: 'center' }}>{saving ? <><Spinner /> Redefinindo...</> : 'Redefinir senha'}</Btn>
    </form>}
    <Btn variant="secondary" onClick={onReturn} disabled={saving} style={{ marginTop: 16, width: '100%', justifyContent: 'center' }}>Voltar ao login</Btn>
  </AuthShell>;
}
ResetPassword.propTypes = { token: PropTypes.string.isRequired, onReturn: PropTypes.func.isRequired };
